// Package imports:
import React from 'react';
import cx from 'classnames';

interface IProps {
    toggled: boolean;
    onToggle: (toggled: boolean) => void;
    label?: string;
    disabled?: boolean;
}

const Toggle: React.FC<IProps> = ({
    toggled,
    onToggle,
    label,
    disabled = false,
}) => {
    const handleClick = () => {
        if (!disabled) {
            onToggle(!toggled);
        }
    };

    return (
        <div
            className={cx('KCL_toggle', {
                'KCL_toggle--active': toggled,
                'KCL_toggle--disabled': disabled,
            })}
        >
            <button
                type="button"
                className="toggle__track"
                onClick={handleClick}
                disabled={disabled}
                role="switch"
                aria-checked={toggled}
            >
                <span className="toggle__knob" />
            </button>
            {label && (
                <span className="toggle__label">{label}</span>
            )}
        </div>
    );
};

export default Toggle;
